var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.308594 14.1914L5.93359 19.8164C6.05469 19.9375 6.21484 20 6.41016 20C6.60547 20 6.72996 19.939 6.85195 19.8169L12.477 14.1919C12.7211 13.9477 12.7211 13.552 12.477 13.3083C12.2328 13.0645 11.8371 13.0641 11.5934 13.3083L7 17.8672V3.125C7 2.09102 7.83984 1.25 8.875 1.25H13.25C13.5955 1.25 13.875 0.970312 13.875 0.625C13.875 0.279687 13.5955 0 13.25 0H8.875C7.15234 0 5.75 1.40156 5.75 3.125V17.8672L1.19141 13.3086C0.947266 13.0645 0.551562 13.0645 0.307812 13.3086C0.0640621 13.5527 0.0625 13.9492 0.308594 14.1914Z",
    fill: "#8D9096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropdown);
export default __webpack_public_path__ + "static/media/arrow-dropdown.13e8bcbf1a2d7d976c8460b3fe06a179.svg";
export { ForwardRef as ReactComponent };